import { useState, useEffect } from 'react';

const MOBILE_BREAKPOINT = 768;

/**
 * True below `breakpoint` px wide. The default (768, Tailwind `md`) is what
 * every dialog/table caller means by "mobile"; pass 1024 (Tailwind `lg`) to
 * track the handheld bottom bar, which is `lg:hidden`.
 */
export function useIsMobile(breakpoint: number = MOBILE_BREAKPOINT): boolean {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.innerWidth < breakpoint;
  });

  useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);
    const onChange = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    mql.addEventListener('change', onChange);
    setIsMobile(mql.matches);
    return () => mql.removeEventListener('change', onChange);
  }, [breakpoint]);

  return isMobile;
}
